import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { useLocation } from 'react-router-dom';
import {
  consoleWarningStyle,
  LOGOUT_REASONS,
  OKTA_LOGOUT_REASON_KEY,
  OKTA_OAUTH_ERROR,
} from '../../utils/constants';
import { Loading } from '@thecb/components';
import { useDispatch, useSelector } from 'react-redux';
import { setIsLoggingOut } from '../login/Login.state';
import { clearLocalStorageSession } from '../../utils/state';

export default function Logout() {
  const { oktaAuth } = useOktaAuth();
  const location = useLocation();
  const { isLoggingOut } = useSelector((state) => state.login);
  const dispatch = useDispatch();
  const hasOktaOAuthError = () =>
    location.search.includes(OKTA_OAUTH_ERROR.queryStr);

  const handleOktaLogout = async () => {
    const logoutReason = localStorage.getItem(OKTA_LOGOUT_REASON_KEY);
    if (!logoutReason) {
      localStorage.setItem(
        OKTA_LOGOUT_REASON_KEY,
        LOGOUT_REASONS.USER_INITIATED.name,
      );
    }
    try {
      if (hasOktaOAuthError()) {
        await oktaAuth.signOut({
          postLogoutRedirectUri: window.location.origin,
        });
        localStorage.setItem(
          OKTA_LOGOUT_REASON_KEY,
          OKTA_OAUTH_ERROR.alertBarMsg,
        );
      } else {
        await oktaAuth.signOut({
          postLogoutRedirectUri: window.location.origin,
        });
      }
      oktaAuth.tokenManager.clear();
      clearLocalStorageSession();
    } catch (err) {
      console.warn(
        `%cWarning: Okta sign out error: ${err}`,
        `background-color: ${consoleWarningStyle}`,
      );
    }
    dispatch(setIsLoggingOut(false));
  };

  useEffect(() => {
    handleOktaLogout();
  }, [isLoggingOut]);

  return <Loading />;
}
